import { render, staticRenderFns } from "./loginCopy.vue?vue&type=template&id=5e5f37f9&scoped=true&"
import script from "./loginCopy.vue?vue&type=script&lang=js&"
export * from "./loginCopy.vue?vue&type=script&lang=js&"
import style0 from "./loginCopy.vue?vue&type=style&index=0&id=5e5f37f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f37f9",
  null
  
)

export default component.exports